import { drawerAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import { mix } from 'color2k';
import { slate } from '../tokens/colors.js';
import { Button } from './button.js';
import { Text } from './text.js';

const { definePartsStyle } = createMultiStyleConfigHelpers(drawerAnatomy.keys);
const dialogContainerStyles = defineStyle((props) => {
  const { closeOnOverlayClick } = props;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    pointerEvents: closeOnOverlayClick ? "auto" : "none"
  };
});
let Drawer = {
  baseStyle: definePartsStyle((props) => ({
    dialog: {
      zIndex: "modal",
      maxH: "100vh",
      minWidth: "16rem",
      maxW: "340px",
      color: "inherit",
      bgColor: "white",
      border: "1px solid transparent",
      pointerEvents: "auto",
      _dark: {
        bgColor: "#121212",
        color: "white"
      },
      '&[data-placement="left"]': {
        borderRightColor: "stroke"
      },
      '&[data-placement="right"]': {
        borderLeftColor: "stroke"
      },
      '&[data-placement="top"]': {
        borderBottomColor: "stroke"
      },
      '&[data-placement="bottom"]': {
        borderTopColor: "stroke"
      }
    },
    dialogContainer: dialogContainerStyles(props),
    body: {
      px: "6",
      py: "2",
      flex: "1",
      overflow: "auto",
      padding: "200"
    },
    overlay: {
      zIndex: "modal",
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      pointerEvents: "none",
      // By default, pointer-events on the dialogContainer & dialog is set to none
      // When the DrawerOverlay is used then we reset the pointer-events to prevent
      // clicking elements behind the overlay.
      "~ div > .chakra-modal__content-container": {
        pointerEvents: "unset"
      },
      "~ div > .chakra-modal__content": {
        pointerEvents: "unset"
      }
    },
    closeButton: {
      ...Button.baseStyle,
      ...Button.sizes?.sm,
      position: "absolute",
      right: "4px",
      top: "6px",
      alignSelf: "flex-end",
      _hover: {
        backgroundColor: mix(slate[100], "white", 0.15)
      },
      svg: {
        width: "10px"
      },
      _dark: {
        ...Button.variants?.minimal
      }
    },
    header: {
      ...Text.variants["header-5"],
      paddingTop: "14px",
      paddingLeft: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    footer: {
      padding: "200"
    }
  })),
  sizes: {
    md: {
      dialog: {
        maxW: "340px"
      }
    },
    full: {
      dialog: {
        maxW: "100%"
      }
    }
  },
  variants: {},
  defaultProps: {
    size: "md"
  }
};

export { Drawer };
